import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { GeneralService } from '../general.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-travel-modal',
  templateUrl: './travel-modal.component.html',
  styleUrls: ['./travel-modal.component.css'],
})
export class TravelModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<TravelModalComponent>,
    private sanitizer: DomSanitizer,
    private s: GeneralService,
    private toaster: ToastrService
  ) {
    this.wallet = JSON.parse(localStorage.getItem('wallet')!);
    this.user = JSON.parse(localStorage.getItem('user')!)
  }

  wallet: { [key: string]: any } = {};
  user: { [key: string]: any } = {};
  datas: { [key: string]: any } = {};
  closey = true;
  selected = false;
  unitsView = false;
  travellerCount: number = 0;

  ngOnInit(): void {
    this.s.loader = false;

    // if(!this.user['unitFn']) {
    //   !this.unitsView
    // }

    if(this.user['role']=== 'staff' || this.user['role']=== 'broker') {
      this.unitsView = true;
    } 
    if(!this.user['unitFn']) {
      this.unitsView = false;
    }
    if(parseInt(this.user['units'], 10) === 0 && this.user['role'] === 'broker') {
      this.unitsView = false;
    }

    const travellerCount = localStorage.getItem('travellerCount');
    this.travellerCount = travellerCount ? JSON.parse(travellerCount) : 0;

  }

  edit() {
    this.dialogRef.close({ action: 'edit' });
  }
  payWithWallet() {
    if (parseFloat(this.wallet['balance']) < parseFloat(this.data['amount']) ) {
      this.s.loader = false;
      this.toaster.warning('Please fund your wallet to proceed');
      this.toaster.error('Insufficient Balance');
    } else {
      this.selected = true;
      this.data['type'] = 'wallet';
      this.s.makePyt(this.data).subscribe((r) => {
        if (r['status']) {
          localStorage.removeItem('qoute');
          this.s
            .getWalletBal()
            .subscribe((r) =>
              localStorage.setItem('wallet', JSON.stringify(r.data))
            );
          this.dialogRef.close({ action: 'success' });
        } else {
          this.toaster.warning(r.message);
        }
      });
    }
  }

  payWithUnits(){
    if(parseFloat(this.user['units']) < 1) {
      this.s.loader = false;
      this.toaster.info('Please Top-up Units', 'Insufficient Units Balance');
    } else {
      this.data['type'] = 'units';
      this.data['unitAmount'] = this.travellerCount;

      this.s.makePyt(this.data).subscribe((r) => {
        if(r['status']) {
           localStorage.setItem('user', JSON.stringify(r.company));
          this.dialogRef.close({ action: 'success' });
          this.s.loader = false;
        }else {
          this.toaster.warning(r.message);
        }
      })
    }
  }

  makePymt(){
    this.s.makePyt(this.data).subscribe((r) => {
      this.s.loader = false;
      this.datas = r;
      localStorage.removeItem('qoute');
      this.goToLink(r);
    });
  }
payWithFlutterwave(){
  this.data['payment_gateway'] = 'flutterwave'
  this.makePymt()

}
payWithPaystack(){
  this.data['payment_gateway'] = 'paystack'
  this.makePymt()
}
  instaPay() {
    this.selected = true;
    // this.s.makePyt(this.data).subscribe((r) => {
    //   this.s.loader = false;
    //   this.datas = r;
    //   localStorage.removeItem('qoute');
    //   this.goToLink(r);
    // });
  }
  goToLink(data: { [key: string]: any }) {
   if(this.data['payment_gateway']  == 'paystack'){
     window.open(data['payment_url']['authorization_url'], '_self');
   }else{
     window.open(data['payment_url']['link'], '_self');
   }
  }
  close() {
    this.dialogRef.close();
  }

  

  cleanURL(oldURL: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(oldURL);
  }
}
